import { Logger, LogManager } from "@mcleod/core";
import { LogicKeyHandling } from "./LogicKeyHandling";

export class GlobalKeyListener {
    private static documentKeyListener: (event: KeyboardEvent) => void;
    private static _log: Logger;

    static _addDocumentKeyListener() {
        // This method should only be called once, but just to be safe make sure we don't add duplicate key listeners
        if (this.documentKeyListener == null) {
            this.getLog().debug("Adding document key listener");
            this.documentKeyListener = LogicKeyHandling.handleKey;
            document.addEventListener("keydown", this.documentKeyListener);
        }
    }

    private static getLog(): Logger {
        if (this._log == null) {
            this._log = LogManager.getLogger("components.keyhandling.GlobalKeyListener");
        }
        return this._log;
    }
}
GlobalKeyListener._addDocumentKeyListener();
